import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {yupResolver} from "@hookform/resolvers/yup";
import {css} from "@panda/css";
import * as Yup from "yup";

import {Button} from "@pg-design/button-module";
import {InputField, TextareaField} from "@pg-design/inputs-module";
import {Link} from "@pg-design/link-module";
import {SystemModal} from "@pg-design/modal-module";
import {CheckboxControlled} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";
import {pickBy} from "@pg-mono/nodash";
import {FormProviderRHF, useFormRHF} from "@pg-mono/react-hook-forms-utils";
import {postRequest} from "@pg-mono/request";
import {apiPath} from "@pg-mono/rp-api-routes";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";

import {validationMessages} from "../../form/utils/validation_messages";
import {addFailureNotification} from "../../notifications/utils/add_failure_notification";
import {addSuccessNotification} from "../../notifications/utils/add_success_notification";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
}

interface FormFields {
    name: string;
    email: string;
    url: string;
    content: string;
    consent: boolean;
}

const reportContentSchema = Yup.object().shape({
    name: Yup.string(),
    email: Yup.string().email(validationMessages.email),
    url: Yup.string().required(validationMessages.required),
    content: Yup.string().required(validationMessages.required),
    consent: Yup.boolean().oneOf([true], validationMessages.required)
});

export const ReportContentModal = (props: IProps) => {
    const {isOpen, onClose} = props;

    const dispatch = useDispatch();

    const {isMobile} = useUserDevice();

    const methods = useFormRHF<FormFields>({
        resolver: yupResolver(reportContentSchema),
        defaultValues: {
            consent: false,
            name: "",
            content: "",
            email: "",
            url: ""
        }
    });

    const {
        register,
        setValue,
        handleSubmit,
        reset,
        formState: {errors}
    } = methods;

    const closeModal = () => {
        onClose();
        reset();
    };

    const onSubmit = (data: FormFields) => {
        closeModal();
        postRequest(
            {},
            apiPath.users.reporting_content,
            pickBy({...data}, (value) => !!value)
        )
            .then(() => {
                dispatch(addSuccessNotification("Twoje zgłoszenie zostało wysłane. Dziękujemy!"));
            })
            .catch(() => {
                dispatch(addFailureNotification("Coś poszło nie tak. Spróbuj później."));
            });
    };

    useEffect(() => {
        if (isOpen) {
            setValue("url", window.location.href);
        }
    }, [isOpen]);

    return (
        <FormProviderRHF {...methods}>
            <SystemModal isOpen={isOpen} onModalClose={closeModal} className={modalStyle}>
                <SystemModal.Header headerTextStyle={{textAlign: isMobile ? "left" : "center"}}>Zgłoś nielegalną treść</SystemModal.Header>
                <SystemModal.Content className={css({p: isMobile ? "1,5rem" : "3rem"})} fullWidth>
                    <form className={formWrapper} onSubmit={handleSubmit(onSubmit)}>
                        <InputField {...register("name")} className={inputStyle} error={errors.name?.message} placeholder="Imię i nazwisko (opcjonalnie)" />
                        <InputField {...register("email")} className={inputStyle} error={errors.email?.message} placeholder="E-mail (opcjonalnie)" />
                        <InputField {...register("url")} className={inputStyle} error={errors.url?.message} disabled />
                        <TextareaField
                            {...register("content")}
                            className={inputStyle}
                            placeholder="Uzasadnienie zgłoszenia (napisz nam, dlaczego ta treść jest nielegalna)"
                            error={errors.content?.message}
                        />

                        <div className={inputWrapper}>
                            <CheckboxControlled
                                name="consent"
                                labelContent="Oświadczam, że dokonuję zgłoszenia w dobrej wierze i według mojej najlepszej wiedzy zawarte w nim informacje, w tym zarzuty dotyczące ogłoszenia są prawdziwe."
                                className={labelStyle}
                            />
                        </div>

                        <Text variant="info_txt_1" color="#000">
                            Zgłoszenia możesz dokonać anonimowo. Możesz także podać swoje imię, nazwisko lub adres e-mail. Administratorem Twoich danych
                            osobowych jest <strong>Property Group sp. z o.o.</strong>&nbsp;
                            <Link underline size="small" href={rpAppLink.rodoTerms.base()} target="_blank">
                                Kliknij i dowiedz się więcej o ochronie Twoich danych.
                            </Link>
                        </Text>

                        <Button variant="filled_primary" type="submit" className={submitButton}>
                            PRZEŚLIJ
                        </Button>
                    </form>
                </SystemModal.Content>
            </SystemModal>
        </FormProviderRHF>
    );
};

const modalStyle = css({
    sm: {
        maxWidth: "652px"
    }
});

const formWrapper = css({
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "1.5rem",
    width: "100%",
    flexBasis: "100%"
});

const submitButton = css({
    width: "225px",
    alignSelf: "center",
    mt: 4
});

const inputStyle = css({
    width: "100%"
});

const inputWrapper = css({
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexBasis: "100%",
    flexDirection: "column"
});

const labelStyle = css({
    color: "var(--colors-secondary)"
});
import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {yupResolver} from "@hookform/resolvers/yup";
import {css} from "@panda/css";
import * as Yup from "yup";

import {Button} from "@pg-design/button-module";
import {InputField, TextareaField} from "@pg-design/inputs-module";
import {Link} from "@pg-design/link-module";
import {SystemModal} from "@pg-design/modal-module";
import {CheckboxControlled} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";
import {pickBy} from "@pg-mono/nodash";
import {FormProviderRHF, useFormRHF} from "@pg-mono/react-hook-forms-utils";
import {postRequest} from "@pg-mono/request";
import {apiPath} from "@pg-mono/rp-api-routes";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";

import {validationMessages} from "../../form/utils/validation_messages";
import {addFailureNotification} from "../../notifications/utils/add_failure_notification";
import {addSuccessNotification} from "../../notifications/utils/add_success_notification";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
}

interface FormFields {
    name: string;
    email: string;
    url: string;
    content: string;
    consent: boolean;
}

const reportContentSchema = Yup.object().shape({
    name: Yup.string(),
    email: Yup.string().email(validationMessages.email),
    url: Yup.string().required(validationMessages.required),
    content: Yup.string().required(validationMessages.required),
    consent: Yup.boolean().oneOf([true], validationMessages.required)
});

export const ReportContentModal = (props: IProps) => {
    const {isOpen, onClose} = props;

    const dispatch = useDispatch();

    const {isMobile} = useUserDevice();

    const methods = useFormRHF<FormFields>({
        resolver: yupResolver(reportContentSchema),
        defaultValues: {
            consent: false,
            name: "",
            content: "",
            email: "",
            url: ""
        }
    });

    const {
        register,
        setValue,
        handleSubmit,
        reset,
        formState: {errors}
    } = methods;

    const closeModal = () => {
        onClose();
        reset();
    };

    const onSubmit = (data: FormFields) => {
        closeModal();
        postRequest(
            {},
            apiPath.users.reporting_content,
            pickBy({...data}, (value) => !!value)
        )
            .then(() => {
                dispatch(addSuccessNotification("Twoje zgłoszenie zostało wysłane. Dziękujemy!"));
            })
            .catch(() => {
                dispatch(addFailureNotification("Coś poszło nie tak. Spróbuj później."));
            });
    };

    useEffect(() => {
        if (isOpen) {
            setValue("url", window.location.href);
        }
    }, [isOpen]);

    return (
        <FormProviderRHF {...methods}>
            <SystemModal isOpen={isOpen} onModalClose={closeModal} className={modalStyle}>
                <SystemModal.Header headerTextStyle={{textAlign: isMobile ? "left" : "center"}}>Zgłoś nielegalną treść</SystemModal.Header>
                <SystemModal.Content className={css({p: isMobile ? "1,5rem" : "3rem"})} fullWidth>
                    <form className={formWrapper} onSubmit={handleSubmit(onSubmit)}>
                        <InputField {...register("name")} className={inputStyle} error={errors.name?.message} placeholder="Imię i nazwisko (opcjonalnie)" />
                        <InputField {...register("email")} className={inputStyle} error={errors.email?.message} placeholder="E-mail (opcjonalnie)" />
                        <InputField {...register("url")} className={inputStyle} error={errors.url?.message} disabled />
                        <TextareaField
                            {...register("content")}
                            className={inputStyle}
                            placeholder="Uzasadnienie zgłoszenia (napisz nam, dlaczego ta treść jest nielegalna)"
                            error={errors.content?.message}
                        />

                        <div className={inputWrapper}>
                            <CheckboxControlled
                                name="consent"
                                labelContent="Oświadczam, że dokonuję zgłoszenia w dobrej wierze i według mojej najlepszej wiedzy zawarte w nim informacje, w tym zarzuty dotyczące ogłoszenia są prawdziwe."
                                className={labelStyle}
                            />
                        </div>

                        <Text variant="info_txt_1" color="#000">
                            Zgłoszenia możesz dokonać anonimowo. Możesz także podać swoje imię, nazwisko lub adres e-mail. Administratorem Twoich danych
                            osobowych jest <strong>Property Group sp. z o.o.</strong>&nbsp;
                            <Link underline size="small" href={rpAppLink.rodoTerms.base()} target="_blank">
                                Kliknij i dowiedz się więcej o ochronie Twoich danych.
                            </Link>
                        </Text>

                        <Button variant="filled_primary" type="submit" className={submitButton}>
                            PRZEŚLIJ
                        </Button>
                    </form>
                </SystemModal.Content>
            </SystemModal>
        </FormProviderRHF>
    );
};

const modalStyle = css({
    sm: {
        maxWidth: "652px"
    }
});

const formWrapper = css({
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "1.5rem",
    width: "100%",
    flexBasis: "100%"
});

const submitButton = css({
    width: "225px",
    alignSelf: "center",
    mt: 4
});

const inputStyle = css({
    width: "100%"
});

const inputWrapper = css({
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexBasis: "100%",
    flexDirection: "column"
});

const labelStyle = css({
    color: "var(--colors-secondary)"
});
